// 根据环境引入不同配置 process.env.VUE_APP_ENV
const environment = process.env.VUE_APP_ENV || 'production';
const config = require('./env.' + environment);

// Vue CLI 只会把以 VUE_APP_ 开头的变量注入到前端环境
const CUSTOM_BASE_API = process.env.VUE_APP_CUSTOM_BASE_API;
if (CUSTOM_BASE_API) {
  config.baseApi = CUSTOM_BASE_API;
}

module.exports = config;
